module.exports = __webpack_public_path__ + "img/separator5.a6aad7f3.svg";